export const classForKey = (key: string) => {
  let className: string;
  if (key === 'timeNull') {
    className = 'bg-dark';
  } else if (key === 'time1Year') {
    className = 'bg-success';
  } else if (key === 'time1Month') {
    className = 'bg-secondary';
  } else if (key === 'time120') {
    className = 'bg-danger';
  } else if (key === 'time24') {
    className = 'bg-warning';
  } else if (key === 'time1') {
    className = 'bg-info';
  } else {
    className = 'bg-success';
  }
  return className;
};